import React, { useState, useEffect, useCallback } from "react";
import BlockedDomains from "./BlockedDomains";
import { getDashboard, blockApps as blockAdultSites } from "../api";
import { useNavigate } from "react-router-dom";
import CustomPopup from "../common/CustomPopup";
import IpConfirmation from "../common/IpConfirmation";
import ProductType from "../constants/Constants";
import { is_user_active } from "../common/Utils";
import { PiSpinner } from "react-icons/pi";
import { Helmet } from "react-helmet";
import {
  hasDashboardData,
  getDashboardData,
  setDashboardData,
  clearDashboardData,
  getLastUpdated,
  setLastUpdated,
  modifyDashboardDataToSession,
} from "../common/StorageUtils";

import {
  getTooltipsUniqueThreats,
  getTooltipsAccessAttempts,
  getTooltipsMalicious,
  getTooltipsScreenRecording,
  getTooltipsKeyStroke,
  getTooltipsAppsNoPrivacy,
  getTooltipsUniqueDomains,
  getTooltipsWebDomains,
  getTooltipsTotalWebDomains,
  getTooltipsAppsBlocked,
  getTooltipsWebDomainsBlocked,
  getTooltipsAdultSitesBlocked,
} from "../common/helperFunctions";

function Dashboard(props) {
  const [currentDate, setCurrentDate] = useState("");
  const [dashBoardDetails, setDashBoardDetails] = useState(null);
  const [appsCount, setappsCount] = useState(0);
  const [websitesCount, setwebsitesCount] = useState(0);
  const [visibility, setVisibility] = useState(false);
  const [ipsetconfirmation, setipsetconfirmation] = useState(false);
  const [isNotKavalan, setIsNotKavalan] = useState(true);
  const [showUpgradeText_, setShowUpgradeText_] = React.useState(false);
  const [threatMeterImage, setThreatMeterImage] = useState(
    "images/Threat-Meter-Low.png",
  );
  const [error, setError] = useState(false);
  const [adultSiteStatus, setAdultSiteStatus] = useState(false);
  const navigate = useNavigate();
  const [mainSpinner, setMainSpinner] = useState(false);
  const [blocked, setBlocked] = useState("Blocked"); //eslint-disable-line
  const [unBlocked, setUnblocked] = useState("Unblocked"); //eslint-disable-line

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!hasDashboardData()) {
      queryAndStoreDashboardData();
    } else {
      set_Dashboard_Viewdata(getDashboardData());
      setCurrentDate(getLastUpdated());
    }
    window.addEventListener("unload", clearDashboardData); //it listens to the click on the "a href" element, but not navigate("/...")
  }, []);

  const getDate = () => {
    const currentDate = new Date();
    var year = currentDate.getFullYear(); //Current Year
    var month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); //Current Month
    var date = currentDate.getDate().toString().padStart(2, "0"); //Current Date
    var hours = currentDate.getHours().toString().padStart(2, "0"); //Current Hours
    var min = currentDate.getMinutes().toString().padStart(2, "0"); //Current Minutes
    var sec = currentDate.getSeconds().toString().padStart(2, "0"); //Current Seconds

    return (
      month + "/" + date + "/" + year + " " + hours + ":" + min + ":" + sec
    );
  };

  const set_Dashboard_Viewdata = (response) => {
    setDashBoardDetails(response?.metadata);
    setThreatMeterImageValue(response?.metadata?.threatMeter);
    if (props.product === ProductType.KAVALAN) {
      setappsCount(response?.custom?.noOfAppsBlocked);
      setwebsitesCount(response?.custom?.noOfWebsitesBlocked);
      setAdultSiteStatus(response?.custom?.adultSites ? blocked : unBlocked);
      setShowUpgradeText_(false);
      setIsNotKavalan(false);
    } else if (
      props.product === ProductType.KAVALAN_LIGHT ||
      props.product === ProductType.TRIAL
    ) {
      setShowUpgradeText_(true);
      setIsNotKavalan(true);
    }
  };

  // Query, view and locally store dashboard data
  const queryAndStoreDashboardData = () => {
    setMainSpinner(true);

    let mounted = true;
    if (!is_user_active(props.currentUser)) {
      setMainSpinner(false);
      navigate("/login");
    } else {
      getDashboard()
        .then((response) => {
          // Store an JSON response to session
          setDashboardData(response);
          setMainSpinner(false);
          setLastUpdated(getDate());
          if (mounted) {
            if (response?.metadata?.ipChanged === true) {
              setVisibility(true);
            }
            set_Dashboard_Viewdata(response);
            setCurrentDate(getLastUpdated());
          }
        })
        .catch((error) => {
          setMainSpinner(false);
          setError(true);
        });
    }
    return () => (mounted = false);
  };

  const setThreatMeterImageValue = (threatMeter) => {
    if (threatMeter === "Low") {
      setThreatMeterImage("images/Threat-Meter-Low.png");
    } else if (threatMeter === "Elevated") {
      setThreatMeterImage("images/Threat-Meter-Elevated.png");
    } else if (threatMeter === "High") {
      setThreatMeterImage("images/Threat-Meter-High.png");
    } else if (threatMeter === "VeryHigh") {
      setThreatMeterImage("images/Threat-Meter-Very-High.png");
    } else {
      setThreatMeterImage("images/Threat-Meter-Low.png");
    }
  };

  const refreshData = () => {
    clearDashboardData();
    queryAndStoreDashboardData();
  };

  const popupIpsetConfirmation = (e) => {
    setipsetconfirmation(true);
    setVisibility(false);
  };

  const updateStatus = useCallback((state) => {
    if (state) {
      window.location.reload();
    }
    setipsetconfirmation(false);
  }, []);
  const notHomeNetwork = useCallback(() => {
    setTimeout(() => {
      setipsetconfirmation(false);
    }, 15000);
  }, []);

  // Unused function delete after 12/31/2024
  // const closePop = (e) => {
  //   setipsetconfirmation(false);
  //   const handleButtonClick = () => {
  //     setPopupVisible(!isPopupVisible);
  //   };

  //   const handleMouseEnter = () => {
  //     setPopupVisible(false);
  //   };

  //   const handleMouseLeave = () => {
  //     setPopupVisible(false);
  //   };

  //   return (
  //     <div>
  //       <div
  //         className={className}
  //         onClick={handleButtonClick}
  //         onMouseEnter={handleMouseEnter}
  //         onMouseLeave={handleMouseLeave}
  //       >
  //         {content}
  //       </div>
  //       {isPopupVisible && (
  //         <div className="insight-popup">
  //           <p>{title}</p>
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  const FetchingSpinner = () => {
    return (
      <div className="waveTextAnimatedDashboard">
        <span>Fetching Data</span>
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </div>
    );
  };

  const ShowUpgradeText = () => (
    <div>
      <hr className="hrstyle"></hr>
      <h3 className="heading-26" style={{ fontWeight: "bold" }}>
        Upgrade to Kavalan Standard is required to access these additional
        features
      </h3>
    </div>
  );

  const blockApps = () => navigate("/blockapps");
  const blockWebsites = () => navigate("/blockwebsites");
  const privacyRiskreport = () => navigate("/privacy-risk-report");
  const privacyScan = () => navigate("/privacy-scan");

  const deepPrivacyAnalysis = () => navigate("/deep-privacy-analysis");
  const [adultSitesInprogress, setAdultSitesInProgress] = React.useState(false);

  const blockSites = (e) => {
    e.preventDefault();
    setAdultSitesInProgress(true);

    var v = e.currentTarget.id;
    let status = adultSiteStatus === unBlocked ? true : false;

    blockAdultSites(v, status)
      .then((res) => {
        modifyDashboardDataToSession("adultSites", res.appStatus);

        setAdultSiteStatus(res.appStatus ? blocked : unBlocked);
        setAdultSitesInProgress(false);
      })
      .catch((error) => {
        setError(true);
        setAdultSitesInProgress(false);
      });
  };
  const AdultSitesStatusSpinner = (e) => {
    var status = e.status === "Blocked" ? "Unblocking" : "Blocking";
    return (
      <div className="waveTextAnimatedDashboard">
        <span>{status}</span>
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </div>
    );
  };

  const tooltipTexts = () => {
    return (
      <i
        class="fa-regular fa-circle-question"
        style={{ marginLeft: "5px" }}
      ></i>
    );
  };

  const Resultsblockappswebsites = () => (
    <div className="action-buttons-section ">
      <div className="showUpgradeText">
        {showUpgradeText_ ? <ShowUpgradeText /> : null}
      </div>

      <h3 className="heading-26">Your Custom Blocking Insights</h3>
      <div>
        (Apps and web domains that you have chosen to block for your home)
      </div>
      <div className="columns-46 w-row">
        <div className="w-col w-col-4">
          <div className="div-block-34">
            <div className="columns-47 w-row">
              <div className="column-96 w-col w-col-6">
                <div className="text-block-143">
                  Apps blocked
                  <div className="tooltip-box">
                    {tooltipTexts()}
                    <span className="tooltiptext">
                      {getTooltipsAppsBlocked()}
                    </span>
                  </div>
                </div>
                <div className="text-block-144">{appsCount}</div>
              </div>
              <div className="column-95 w-col w-col-6">
                <div className="block-apps-button" />
              </div>
            </div>
          </div>
        </div>

        <div className="w-col w-col-4">
          <div className="div-block-35">
            <div className="columns-48 w-row">
              <div className="column-97 w-col w-col-6">
                <div className="text-block-145">
                  Web domains blocked
                  <div className="tooltip-box">
                    {tooltipTexts()}
                    <span className="tooltiptext">
                      {getTooltipsWebDomainsBlocked()}
                    </span>
                  </div>
                </div>
                <div className="text-block-146">{websitesCount}</div>
              </div>
              <div className="column-98 w-col w-col-6">
                <div className="block-websites-button"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-col w-col-4">
          <div className="div-block-64">
            <div className="columns-56 w-row">
              <div className="column-115 w-col w-col-6">
                <div className="text-block-179">
                  Adult sites blocked
                  <div className="tooltip-box">
                    {tooltipTexts()}
                    <span className="tooltiptext">
                      {getTooltipsAdultSitesBlocked()}
                    </span>
                  </div>
                </div>
                <div className="text-block-180">
                  {adultSitesInprogress ? (
                    <AdultSitesStatusSpinner status={adultSiteStatus} />
                  ) : (
                    adultSiteStatus
                  )}
                </div>
              </div>
              <div className="column-116 w-col w-col-6">
                <div className="adult-button">18+</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h3 className="heading-26">Take Action and View Advanced Insights</h3>
        <div>Take action, customize what is blocked, view advanced reports</div>

        <div className="div-block-60">
          <div className="grid-4">
            {" "}
            {/*it was className="w-layout-grid grid-4"*/}
            <div className="button-container">
              <button
                className={`kavalan-button-new w-button ${
                  isNotKavalan ? "disabled" : ""
                }`}
                onClick={blockApps}
                disabled={isNotKavalan}
                style={isNotKavalan ? { boxShadow: "none" } : {}}
              >
                block/unblock an app
              </button>
            </div>
            <div className="button-container">
              <button
                className={`kavalan-button-new w-button ${
                  isNotKavalan ? "disabled" : ""
                }`}
                onClick={blockWebsites}
                disabled={isNotKavalan}
                style={isNotKavalan ? { boxShadow: "none" } : {}}
              >
                block/unblock a web domain
              </button>
            </div>
            <div className="button-container">
              <button
                className={`kavalan-button-new w-button ${
                  isNotKavalan ? "disabled" : ""
                }`}
                id="adultsites"
                onClick={blockSites}
                disabled={isNotKavalan}
                style={isNotKavalan ? { boxShadow: "none" } : {}}
              >
                {adultSitesInprogress ? (
                  <div className="pageload-spinner">
                    <PiSpinner
                      style={{
                        fontSize: "3rem",
                        animation: "spin 2s linear infinite",
                      }}
                    />
                  </div>
                ) : (
                  "block/unblock adult content"
                )}
              </button>
            </div>
            <div className="button-container">
              <button
                className={`kavalan-button-new w-button ${
                  isNotKavalan ? "disabled" : ""
                }`}
                onClick={privacyScan}
                disabled={isNotKavalan}
                style={isNotKavalan ? { boxShadow: "none" } : {}}
              >
                scan a site for privacy risks
              </button>
            </div>
            <div className="button-container">
              <button
                className={`kavalan-button-new w-button ${
                  isNotKavalan ? "disabled" : ""
                }`}
                onClick={deepPrivacyAnalysis}
                disabled={isNotKavalan}
                style={isNotKavalan ? { boxShadow: "none" } : {}}
              >
                data exposure Risk Report
              </button>
            </div>
            <div className="button-container">
              <button
                className={`kavalan-button-new w-button ${
                  isNotKavalan ? "disabled" : ""
                }`}
                onClick={privacyRiskreport}
                disabled={isNotKavalan}
              >
                web privacy risk report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <div>
          <button
            className="yesterday-button"
            // added button for alignment purposes
            //add "YESTERDAY" once the feature is implemented
          ></button>
        </div>
        <div className="refresh-section">
          <button className={`refresh-button w-button`} onClick={refreshData}>
            {mainSpinner ? (
              <div className="pageload-spinner">
                <PiSpinner
                  style={{
                    fontSize: "2rem",
                    animation: "spin 2s linear infinite",
                  }}
                />
              </div>
            ) : (
              <span style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="images/Refresh_new.png"
                  loading="lazy"
                  width="25"
                  height="25"
                  alt=""
                  style={{ marginRight: "5px" }}
                />
                Refresh
              </span>
            )}
          </button>
          <div className="text-block-139">Last Update : {currentDate}</div>
        </div>
        <div>
          <Helmet>
            <script src="https://js.storylane.io/js/v1/storylane.js"></script>
          </Helmet>
          <button
            className="tutorial-button"
            onClick={() =>
              // eslint-disable-next-line
              Storylane.Play({
                type: "popup",
                demo_type: "image",
                width: 2560,
                height: 1442,
                scale: "0.95",
                demo_url: "https://app.storylane.io/share/5pzauit2tsie",
                padding_bottom: "calc(56.33% + 27px)",
              })
            }
          >
            <i
              className="fa-regular fa-circle-play"
              style={{ marginRight: "5px", paddingBottom: "10px" }}
            ></i>
            DASHBOARD TUTORIAL
          </button>
        </div>
      </div>

      <div className="threat-meter-section wf-section">
        <div className="text-block-86">Privacy and Security Threat Summary</div>
        <div className="text-block-131">(Last 24 hours)</div>
        <div className="threat-meter-column w-row">
          <div className="w-col w-col-4"></div>
          <div className="column-74 w-col w-col-4">
            <img
              src={threatMeterImage}
              loading="lazy"
              width="290"
              title="A summary of the level of threat to your online privacy and security that we detected and blocked in your home in the last 24 hours"
              sizes="(max-width: 479px) 61vw, (max-width: 767px) 290px, 27vw"
              alt=""
            />
          </div>

          <div className="w-col w-col-4"></div>
        </div>
      </div>
      <div className="FetchingAndSpinner">{mainSpinner}</div>

      <div className="privacy-insights-section wf-section">
        <div className="text-block-137">
          {mainSpinner === true ? (
            <div
              className="spinner-main"
              style={{ marginTop: "3px", marginBottom: "15px" }}
            >
              <FetchingSpinner />
            </div>
          ) : (
            ""
          )}
          Privacy and Security Insights
          {error === true ? (
            <div className="dashbaord-timeout">
              Oops! We hit a snag. We are aware of it and will fix ASAP.
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="text-block-132">
          (Trackers and Malicious Domains - Last 24 hours)
        </div>
        <div className="privacy-insights-columns w-row">
          <div className="column-82 w-col w-col-4">
            <div className="div-block-24">
              <div className="columns-40 w-row">
                <div className="column-76 w-col w-col-7">
                  <div className="text-block-127">
                    Unique Threats Blocked
                    <div className="tooltip-box">
                      {tooltipTexts()}
                      <span className="tooltiptext">
                        {getTooltipsUniqueThreats()}
                      </span>
                    </div>
                  </div>
                  <div className="text-block-80">
                    {dashBoardDetails != null
                      ? dashBoardDetails.noOfUniqueDomainsBlocked
                      : 0}
                  </div>
                </div>
                <div className="column-77 w-col w-col-5">
                  <img
                    src="images/Unique-Trackers-Blocked_BK.png"
                    loading="lazy"
                    width="75"
                    height="75"
                    srcSet="images/Unique-Trackers-Blocked_BK-p-500.png 500w, images/Unique-Trackers-Blocked_BK-p-800.png 800w, images/Unique-Trackers-Blocked_BK-p-1080.png 1080w, images/Unique-Trackers-Blocked_BK.png 1132w"
                    sizes="75px"
                    alt=""
                    className="image-25"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="column-83 w-col w-col-4">
            <div className="div-block-25">
              <div className="columns-41 w-row">
                <div className="column-78 w-col w-col-7">
                  <div className="text-block-128">
                    Access Attempts Blocked
                    <div className="tooltip-box">
                      {tooltipTexts()}
                      <span className="tooltiptext">
                        {getTooltipsAccessAttempts()}
                      </span>
                    </div>
                  </div>
                  <div className="text-block-84">
                    {dashBoardDetails != null
                      ? dashBoardDetails.noOfDomainsBlocked
                      : 0}
                  </div>
                </div>
                <div className="column-79 w-col w-col-5">
                  <img
                    src="images/Access-Atempts-Blocked_BK.png"
                    loading="lazy"
                    width="75"
                    height="75"
                    srcSet="images/Access-Atempts-Blocked_BK-p-500.png 500w, images/Access-Atempts-Blocked_BK-p-800.png 800w, images/Access-Atempts-Blocked_BK-p-1080.png 1080w, images/Access-Atempts-Blocked_BK.png 1179w"
                    sizes="(max-width: 479px) 27vw, 75px"
                    alt=""
                    className="image-21"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="column-84 w-col w-col-4">
            <div className="div-block-26">
              <div className="columns-42 w-row">
                <div className="column-80 w-col w-col-7">
                  <div className="text-block-129">
                    Malicious Domains Blocked
                    <div className="tooltip-box">
                      {tooltipTexts()}
                      <span className="tooltiptext">
                        {getTooltipsMalicious()}
                      </span>
                    </div>
                  </div>
                  <div className="text-block-130">
                    {dashBoardDetails != null
                      ? dashBoardDetails.noOfUniqueMalwareDomainsBlocked
                      : 0}
                  </div>
                </div>
                <div className="column-81 w-col w-col-5">
                  <img
                    src="images/melicious-sites-blocked_BK.png"
                    loading="lazy"
                    width="75"
                    height="75"
                    srcSet="images/melicious-sites-blocked_BK-p-500.png 500w, images/melicious-sites-blocked_BK-p-800.png 800w, images/melicious-sites-blocked_BK-p-1080.png 1080w, images/melicious-sites-blocked_BK.png 1455w"
                    sizes="(max-width: 479px) 27vw, 75px"
                    alt=""
                    className="image-22"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="column-82 w-col w-col-4">
            <div className="div-block-24">
              <div className="columns-40 w-row">
                <div className="column-76 w-col w-col-7">
                  <div className="text-block-127">
                    Screen Recording Sites
                    <br />
                    Detected
                    <div className="tooltip-box">
                      {tooltipTexts()}
                      <span className="tooltiptext">
                        {getTooltipsScreenRecording()}
                      </span>
                    </div>
                  </div>
                  <div className="text-block-80">
                    {dashBoardDetails != null
                      ? dashBoardDetails.noOfScreenRecordingSites
                      : 0}
                  </div>
                </div>
                <div className="column-77 w-col w-col-5">
                  <img
                    src="images/icons_12.png"
                    loading="lazy"
                    width="75"
                    height="75"
                    sizes="75px"
                    alt=""
                    className="image-25"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="column-83 w-col w-col-4">
            <div className="div-block-25">
              <div className="columns-41 w-row">
                <div className="column-78 w-col w-col-7">
                  <div className="text-block-128">
                    Key Stroke Logging Sites
                    <br />
                    Detected
                    <div className="tooltip-box">
                      {tooltipTexts()}
                      <span className="tooltiptext">
                        {getTooltipsKeyStroke()}
                      </span>
                    </div>{" "}
                  </div>
                  <div className="text-block-84">
                    {dashBoardDetails != null
                      ? dashBoardDetails.noOfKeyLoggingSites
                      : 0}
                  </div>
                </div>
                <div className="column-79 w-col w-col-5">
                  <img
                    src="images/icons_15.png"
                    loading="lazy"
                    width="75"
                    height="75"
                    sizes="(max-width: 479px) 27vw, 75px"
                    alt=""
                    className="image-21"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="column-84 w-col w-col-4">
            <div className="div-block-26">
              <div className="columns-42 w-row">
                <div className="column-80 w-col w-col-7">
                  <div className="text-block-129">
                    Apps With No Privacy
                    <br />
                    Policy
                    <div className="tooltip-box">
                      {tooltipTexts()}
                      <span className="tooltiptext">
                        {getTooltipsAppsNoPrivacy()}
                      </span>
                    </div>
                  </div>
                  <div className="text-block-130">
                    {dashBoardDetails != null
                      ? dashBoardDetails.noOfNoPrivacyPolicyApps
                      : 0}
                  </div>
                </div>
                <div className="column-81 w-col w-col-5">
                  <img
                    src="images/icons_28.png"
                    loading="lazy"
                    width="75"
                    height="75"
                    sizes="(max-width: 479px) 27vw, 75px"
                    alt=""
                    className="image-22"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="internet-activity-section wf-section">
        <div className="text-block-85">Internet Activity Insights</div>
        <div>(What was accessed- Last 24 hours)</div>
        <div className="activity-insights-row w-row">
          <div className="column-92 w-col w-col-4">
            <div className="div-block-27">
              <div className="columns-43 w-row">
                <div className="column-85 w-col w-col-7">
                  <div className="text-block-134">
                    Unique Web Domains
                    <div className="tooltip-box">
                      {tooltipTexts()}
                      <span className="tooltiptext">
                        {getTooltipsUniqueDomains()}
                      </span>
                    </div>
                  </div>
                  <div className="text-block-80">
                    {dashBoardDetails != null
                      ? dashBoardDetails.noOfUniqueDomainsInvoked
                      : 0}
                  </div>
                </div>
                <div className="column-86 w-col w-col-5">
                  <img
                    src="images/web-domains-accessed-10pm-6am_BK.png"
                    loading="lazy"
                    width="75"
                    height="75"
                    srcSet="images/web-domains-accessed-10pm-6am_BK-p-500.png 500w, images/web-domains-accessed-10pm-6am_BK-p-800.png 800w, images/web-domains-accessed-10pm-6am_BK-p-1080.png 1080w, images/web-domains-accessed-10pm-6am_BK.png 1294w"
                    sizes="(max-width: 479px) 27vw, 75px"
                    alt=""
                    className="image-23"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="column-93 w-col w-col-4">
            <div className="div-block-28">
              <div className="columns-44 w-row">
                <div className="column-87 w-col w-col-7">
                  <div className="text-block-135">
                    Web Domains  (10pm - 6am)
                    <div className="tooltip-box">
                      {tooltipTexts()}
                      <span className="tooltiptext">
                        {getTooltipsWebDomains()}
                      </span>
                    </div>
                  </div>
                  <div className="text-block-81">
                    {dashBoardDetails != null
                      ? dashBoardDetails.noOfDomainsInvokedDuringBedTime
                      : 0}
                  </div>
                </div>
                <div className="column-89 w-col w-col-5">
                  <img
                    src="images/Moon-and-Star.png"
                    loading="lazy"
                    width="75"
                    height="75"
                    alt=""
                    className="image-24"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="column-91 w-col w-col-4">
            <div className="div-block-29">
              <div className="columns-45 w-row">
                <div className="column-88 w-col w-col-7">
                  <div className="text-block-136">
                    Total Web Domains
                    <div className="tooltip-box">
                      {tooltipTexts()}
                      <span className="tooltiptext">
                        {getTooltipsTotalWebDomains()}
                      </span>
                    </div>{" "}
                  </div>
                  <div className="text-block-80">
                    {dashBoardDetails != null
                      ? dashBoardDetails.noOfDomainsInvoked
                      : 0}
                  </div>
                </div>
                <div className="column-90 w-col w-col-5">
                  <img
                    src="images/total-web-domains-accessed_BK.png"
                    loading="lazy"
                    width="75"
                    height="75"
                    srcSet="images/total-web-domains-accessed_BK-p-500.png 500w, images/total-web-domains-accessed_BK-p-800.png 800w, images/total-web-domains-accessed_BK-p-1080.png 1080w, images/total-web-domains-accessed_BK.png 1273w"
                    sizes="(max-width: 479px) 27vw, (max-width: 767px) 75px, (max-width: 991px) 71.046875px, 75px"
                    alt=""
                    className="image-26"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="blocked-domain-section wf-section">
        <div className="text-block-85">Blocked Domain Insights</div>
        <div className="text-block-133">
          (What we automatically blocked - Last 24 hours)
        </div>
        <div className="w-layout-blockcontainer w-container">
          <div className="text-block-126">
            Click on a bubble to see details of websites blocked
          </div>
          <div className="bubble-chart-columns w-row">
            {/* <div className="w-col w-col-4"></div> */}
            <div className="column-75 ">
              <div className="refresh-section">
                <button
                  className={`refresh-button w-button`}
                  onClick={refreshData}
                >
                  {mainSpinner ? (
                    <div className="pageload-spinner">
                      <PiSpinner
                        style={{
                          fontSize: "2rem",
                          animation: "spin 2s linear infinite",
                        }}
                      />
                    </div>
                  ) : (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src="images/Refresh_new.png"
                        loading="lazy"
                        width="25"
                        height="25"
                        alt=""
                        style={{ marginRight: "5px" }}
                      />
                      Refresh
                    </span>
                  )}
                </button>
                <div>
                  {mainSpinner === true ? (
                    <div
                      className="spinner-main"
                      style={{ marginTop: "3px", marginBottom: "15px" }}
                    >
                      <FetchingSpinner />
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="text-block-139">
                  Last Update : {currentDate}
                </div>
              </div>
              <div className="centerAlign">
                <br />
                <BlockedDomains
                  //width="400"
                  //height="400"
                  domainsBlocked={
                    dashBoardDetails != null
                      ? dashBoardDetails.domainsBlocked
                      : null
                  }
                  uniqueMalwareDomainsBlocked={
                    dashBoardDetails != null
                      ? dashBoardDetails.uniqueMalwareDomainsBlocked
                      : null
                  }
                  product={props.product}
                />
              </div>
            </div>
          </div>
          <div className="w-col w-col-4"></div>
        </div>
      </div>
      <div>{<Resultsblockappswebsites />}</div>
      <CustomPopup show={visibility}>
        <div>
          <div className="popup-text-block-160">
            <strong className="bold-text-96">
              Alert
              <br />
              <br />
            </strong>
            Your home disconnected from the Kavalan service. Please read below
            to re-enable Kavalan protection for your home
          </div>
          <div className="popup-text-block-161">
            <strong>
              Why did this happen?
              <br />
            </strong>
            This likely happened because your internet service provider changed
            your home's public IP&nbsp;address.
          </div>
          <div className="popup-text-block-162">
            <strong>
              How can we fix this?
              <br />
            </strong>
            Easy! Just click the 'Reconnect to Kavalan' button below when you
            are connected on your home w-fi network.
          </div>
          <div className="div-block-48">
            <div
              onClick={popupIpsetConfirmation}
              className="button-19 w-button"
            />
            <div className="popup-text-block-163">
              Click to reconnect to Kavalan
            </div>
          </div>
        </div>
      </CustomPopup>
      {ipsetconfirmation && (
        <IpConfirmation
          onUpdateStatus={updateStatus}
          onNotConnected={notHomeNetwork}
        />
      )}
    </div>
  );
}

export default Dashboard;
